module.exports = __webpack_public_path__ + "img/farzana-christopher-99.66e3d299.jpg";